<div
  class="fade modal-lg modal"
  id="exerciseFormModal"
  tabindex="-1"
  aria-labelledby="exerciseFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1
          class="modal-title fs-5"
          id="exerciseFormModalLabel"
          *ngIf="editing"
        >
          Edición de un ejercicio
        </h1>
        <h1
          class="modal-title fs-5"
          id="exerciseFormModalLabel"
          *ngIf="!editing"
        >
          Creación de un ejercicio
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="clearAllFields()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="exerciseForm">
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Título"
              formControlName="name"
            />

            <label for="">Título</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre válido
            </div>
          </div>

          <div class="input-group">
            <div class="form-floating mb-3">
              <textarea
                class="form-control"
                type="text"
                [ngClass]="{
                  'is-invalid': description.invalid && description.touched
                }"
                placeholder="Descripción"
                formControlName="description"
                style="height: 250px"
              ></textarea>

              <label for="">Descripción (opcional)</label>
            </div>
          </div>
          <div
            *ngIf="description.invalid && description.touched"
            class="text-danger"
          >
            Ingrese una descripción valida.
          </div>

          <span>Grupo Muscular</span>
          <select
            class="form-select form-select mb-3"
            aria-label="Small select example"
            formControlName="muscleGroup"
          >
            <option [value]="null" selected>
              Selecciona un Grupo Muscular
            </option>
            <option [value]="mg.id" *ngFor="let mg of muscleGroups">
              {{ mg.name }}
            </option>
          </select>

          <select
            class="form-select"
            aria-label="Small select example"
            formControlName="gymMachine"
          >
            <option [value]="null" selected>Selecciona una máquina</option>
            <option
              [value]="gymMachine.id"
              *ngFor="let gymMachine of gymMachines"
            >
              {{ gymMachine.name }}
            </option>
          </select>
        </form>

        <button
          [disabled]="exerciseForm.invalid"
          class="col-12 mt-2 d-grid btn-custom"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onSubmit()"
        >
          <span *ngIf="editing">Editar</span>
          <span *ngIf="!editing">Crear</span>
        </button>

        <div class="mt-3" *ngIf="editing">
          <h2>Tutoriales</h2>
          <table class="table table-hover" *ngIf="editing && isMobile">
            <thead>
              <tr>
                <th scope="col">Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tutorial of exercise?.tutorials">
                <td
                  data-bs-toggle="modal"
                  data-bs-target="#userInfoModal"
                  (click)="selectTutorial(tutorial)"
                >
                  Nombre
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-hover" *ngIf="editing && !isMobile">
            <thead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Descripción</th>
                <th scope="col">Tipo de Recurso</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tutorial of exercise?.tutorials">
                <td>{{ tutorial.name }}</td>
                <td>{{ tutorial.description }}</td>
                <td>{{ formatTranslation[tutorial.format] }}</td>
                <td>
                  <button
                    class="btn btn-danger"
                    *ngIf="exercise"
                    (click)="deleteTutorial(tutorial)"
                  >
                    Eliminar tutorial
                  </button>
                </td>
                <!-- <td>{{ user.firstName }} {{ user.lastName }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.phoneNumber }}</td>
                <td>{{ user.createdAt }}</td> -->
                <!-- <td>
                  <div class="d-flex justify-content-arround">
                    <button
                      class="btn-custom me-2"
                      [routerLink]="['/routines/', user.id]"
                      (click)="selectUser(user)"
                    >
                      Rutinas
                    </button>
                    <button
                      class="btn-custom"
                      [routerLink]="['/diet-history/', user.id]"
                      (click)="selectUser(user)"
                    >
                      alimentación
                    </button>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>

          <button
            class="btn-custom"
            data-bs-toggle="modal"
            data-bs-target="#tutorialFormModal"
            (click)="addTutorial()"
            *ngIf="
              exercise && exercise.tutorials && exercise.tutorials.length == 0
            "
          >
            + Agregar Tutorial
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
